const login = {
  state: {
    loginAccount: localStorage.getItem('loginAccount') || '',
    loginType: localStorage.getItem('loginType') || ''
  },

  mutations: {
    SET_LOGIN_ACCOUNT: (state, account) => {
      state.loginAccount = account
      if (!account) {
        localStorage.removeItem('loginAccount')
      } else {
        localStorage.setItem('loginAccount', account)
      }
    },
    SET_LOGIN_TYPE: (state, type) => {
      state.loginType = type
      if (!type) {
        localStorage.removeItem('loginType')
      } else {
        localStorage.setItem('loginType', type)
      }
    }
  },

  actions: {
    
  }
}

export default login
